export const authKeys = {
  all: ['auth'] as const,
  lists: () => [...authKeys.all, 'list'] as const,
  list: (filters?: unknown) => [...authKeys.lists(), filters] as const,
  details: () => [...authKeys.all, 'detail'] as const,
  detail: (id: string) => [...authKeys.details(), id] as const,
  currentUser: ['auth', 'currentUser'] as const,
};
